import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  containerCampos: {
    paddingBottom: theme.spacing(3),
  },
  titleCampo: {
    fontSize: '15px',
    marginTop: theme.spacing(2),
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },

  labelInput: {
    fontSize: '16px',
  },
  fieldGroup: {
    padding: theme.spacing(2),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
}))

export default useStyles
